<div class="flex gap-16" data-cy="legends-container">
  <div
    *ngFor="let legend of content.types"
    class="flex gap-[5px] items-center"
    data-cy="legend-item"
  >
    <span
      class="w-[14px] h-[14px] rounded-full"
      [class]="legend.className"
      data-cy="legend-icon"
    ></span>

    <span
      class="text-label-xs-medium font-[350] capitalize text-[#161B38]"
      data-cy="legend-title"
    >
      {{ legend.title }}
    </span>
  </div>
</div>
